import { save } from "ionicons/icons";

import toast from "react-hot-toast";

import { addSavedStrategy } from "../lib/firebase";
import { useUsersStore } from "../stores/users.store";
import { useAuthStore } from "../stores/auth.store";
import { IonButton, IonIcon } from "@ionic/react";

interface Props {
  bot: any;
}

const SaveStrategyButton: React.FC<Props> = ({ bot }) => {
  const uid = useAuthStore(state => state.user?.uid);
  const isFavourite = useUsersStore(state =>
    state.isFavourite(bot?.id || bot?.botId)
  );

  const handleSaveStrategy = async () => {
    console.log(bot);
    const strategy = {
      botId: bot?.id || bot?.botId || "",
      profit: bot?.profit || 0,
      user: uid,
      createdAt: Date.now()
    };
    await addSavedStrategy(strategy);
    console.log(strategy);
    toast.success("Strategy saved");
  };

  return (
    <>
      {isFavourite && !bot?.private ? (
        <div className="bg-primary-50 rounded text-sm p-2">Saved</div>
      ) : (
        <IonButton color="primary" size="small" onClick={handleSaveStrategy}>
          Save Strategy
          <IonIcon slot="end" icon={save} />
        </IonButton>
      )}
    </>
  );
};
export default SaveStrategyButton;
